// src/api/notifications.js
import api from '@/utils/axios'

export const notificationCenterApi = {
  // In-app notifications
  list:         (params) => api.get('/notification-center', { params }),
  unreadCount:  ()       => api.get('/notification-center/unread-count'),
  markRead:     (id)     => api.post(`/notification-center/${id}/read`),
  markAllRead:  ()       => api.post('/notification-center/mark-all-read'),
  delete:       (id)     => api.delete(`/notification-center/${id}`),

  // Preferences
  getPreferences:    ()     => api.get('/notification-center/preferences'),
  updatePreferences: (data) => api.put('/notification-center/preferences', data),

  // Scheduled reminders (admin)
  listReminders:  (params) => api.get('/notification-center/reminders', { params }),
  createReminder: (data)   => api.post('/notification-center/reminders', data),
  cancelReminder: (id)     => api.delete(`/notification-center/reminders/${id}`),
}
